import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
export const GlobalModal = React.forwardRef(
  (
    {
      isOpen,
      dialogClassName,
      modalTitle,
      modalClassName,
      isCloseButtonDisplay,
      isHeaderDisplay,
      isBodyDisplay,
      isFooterDisplay,
      children,
      closeButtonIcon,
      ...rest
    },
    ref
  ) => {
    const [open, setOpen] = useState(false);
    useEffect(() => {
      isOpen && handleOpen();
    });

    const handleOpen = () => {
      setOpen(true);
    };

    const handleClose = (e) => {
      setOpen(false);
      rest.onModalClose && rest.onModalClose(e, true);
    };

    return (
      <Modal
        dialogClassName={dialogClassName || ""}
        className={modalClassName || ""}
        show={open}
        onHide={(e) => handleClose(e)}
        id={rest.id}
        backdrop={rest?.backdrop}
        keyboard={rest?.keyboard}
        {...rest}
      >
        {isHeaderDisplay && (
          <Modal.Header>
            <>
              <h5 className="modal-title">{modalTitle}</h5>

              {isCloseButtonDisplay && (
                <button
                  onClick={(e) => handleClose(e)}
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  {closeButtonIcon ? (
                    <i className="bi bi-x"></i>
                  ) : (
                    <img src="assets/images/close_icon.png" alt="" />
                  )}
                </button>
              )}
            </>
          </Modal.Header>
        )}
        {(isBodyDisplay || true) && <Modal.Body>{children}</Modal.Body>}
        {(isFooterDisplay || false) && <Modal.Footer></Modal.Footer>}
      </Modal>
    );
  }
);
GlobalModal.displayName = "GlobalModal";
